import { getOwnConfig } from '@embroider/macros';
import config from 'editor/config/environment';

export default function version(includeDate = true) {
  const version = (<string>config.APP['version'] ?? '').split('+')[0];
  if (!includeDate) return `v${version}`;
  const versionDate = (<any>getOwnConfig()).versionDate;
  return `v${version} (${versionDate})`;
}
